import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { combineLatest, of, switchMap } from 'rxjs';
import { OIDC_PROVIDER_ID } from '../models/tenant-access';
import { AuthenticationService } from '../services/authentication.service';
import { TenantAccessService } from '../services/tenant-access.service';

export const loginProviderGuard = (next: ActivatedRouteSnapshot) => {
    const authenticationService = inject(AuthenticationService);
    const tenantAccess = inject(TenantAccessService);
    return combineLatest([
        authenticationService.getSignInProviderFromToken(),
        tenantAccess.loadTenantAccess(next.params.tenant),
    ]).pipe(
        switchMap(([provider, tenantAccess]) => {
            if (
                (provider === OIDC_PROVIDER_ID && tenantAccess?.loginMethods?.microsoft?.hide === true) ||
                (provider === 'password' && tenantAccess?.loginMethods?.emailPassword === false)
            ) {
                return authenticationService.logoutAndRedirect([next.params.tenant, 'login']);
            }
            return of(true);
        }),
    );
};
